
        var result = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./search-results-tool.component.styl");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/search-results-tool/search-results-tool.component.styl
// module id = 1155
// module chunks = 0